import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TenantDto } from '@nusign/picflow-backend-types';
import { lastValueFrom } from 'rxjs';
import { GROWTHBOOK } from '../growthbook';
import { isTenantBlocked } from '../lib/is-tenant-blocked';
import { IGNORE_MAINTENANCE } from '../network-interceptor';
import { AppConfigService } from '../providers/config.service';
import { DataLoaderService } from './data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class PublicTenantService {
  private http = inject(HttpClient);
  private config = inject(AppConfigService);
  private loader = inject(DataLoaderService);
  private growthBook = inject(GROWTHBOOK);

  private async filterTenant(tenant: TenantDto) {
    const filterTenant = await isTenantBlocked(tenant, this.growthBook);
    return filterTenant ? undefined : tenant;
  }

  public async getTenant(tenantPath: string): Promise<TenantDto> {
    return this.loader.get('public-tenant' + tenantPath, async () => {
      try {
        return this.filterTenant(
          await lastValueFrom(
            this.http.get<TenantDto>(
              `${this.config.apiEndpoint}/tenants/path/${tenantPath}?include[]=tenant_product_name`,
              {
                context: new HttpContext().set(IGNORE_MAINTENANCE, true),
              }
            )
          )
        );
      } catch (err) {
        if (!(err instanceof HttpErrorResponse)) throw err;
        if (err.status === 503) throw err;
        return;
      }
    });
  }

  public async getTenantFromCustomDomain(customDomain: string): Promise<TenantDto> {
    return this.loader.get('public-tenant' + customDomain, async () => {
      try {
        return this.filterTenant(
          await lastValueFrom(
            this.http.get<TenantDto>(`${this.config.apiEndpoint}/tenants/domain?include[]=tenant_product_name`, {
              context: new HttpContext().set(IGNORE_MAINTENANCE, true),
            })
          )
        );
      } catch (err) {
        if (!(err instanceof HttpErrorResponse)) throw err;
        if (err.status === 503) throw err;
        return;
      }
    });
  }
}
